import styles from "./Group.module.scss";
import { Group } from "./groupSlice";
import { bgColorbyName, groupColors } from "src/variable/randomColor";
import { EMPTY_STRING, groupTypeMapping } from "src/components/constant/constant";
import { Avatar } from "@mui/material";
import { Link } from "react-router-dom";

const columns = [
  {
    title: "Id",
    dataIndex: "group_id",
    key: "group_id"
  },
  {
    title: "Display Id",
    dataIndex: "display_id",
    key: "display_id"
  },
  {
    title: "Title",
    dataIndex: "name",
    key: "name"
  },

  {
    title: "Owner",
    dataIndex: "name",
    key: "name",
    // width: 150,
    render: (name: string, data: Group) => (
      <Link to={`/users/${data?.owner?.user_id}`} className={styles.tableMember}>
        <div className={styles.tableMemberImg}>
          <Avatar
            id="av"
            aria-label="Recipe"
            style={{ backgroundColor: bgColorbyName(data?.owner?.attributes?.first_name) }}
          >
            {data?.owner?.attributes?.first_name?.charAt(0).toLocaleUpperCase()}
          </Avatar>
        </div>
        <div className={styles.tableMemberDetail}>
          <div
            className={styles.tableMemberName}
          >{`${data?.owner?.attributes?.first_name} ${data?.owner?.attributes?.last_name}`}</div>
          <div className={styles.tableMemberEmail}>{`${data?.owner?.email}`}</div>
        </div>
      </Link>
    )
  },
  {
    title: "Group Type",
    dataIndex: "group_type",
    key: "group_type",
    render: (group_type: string) => (
      <div>
        <div
          className={styles.role}
          style={{
            backgroundColor: `${groupColors[group_type]}0d`,
            borderColor: `${groupColors[group_type]}73`,
            color: `${groupColors[group_type]}FF`
          }}
        >
          {groupTypeMapping[group_type]}
        </div>
      </div>
    )
  },
  {
    title: "Status",
    dataIndex: "group_status",
    key: "group_status",
    render: (group_status: boolean) => (
      <div className={styles.tableStatus}>
        <div className={`${group_status ? styles.green : styles.grey}`}>{group_status ? "Active" : "Inactive"}</div>
      </div>
    )
  },
  {
    title: EMPTY_STRING,
    dataIndex: EMPTY_STRING,
    key: "operations",
    render: (data: Group) => (
      <div className={styles.edit}>
        <Link to={`/groups/${data.group_id}`} aria-label={`Edit group ${data.name}`} title={`Edit group ${data.name}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M8.88541 3.05214L10.9478 5.11453M9.76042 2.17714C10.3299 1.60762 11.2533 1.60762 11.8228 2.17714C12.3924 2.74665 12.3924 3.67002 11.8228 4.23953L3.79167 12.2707H1.75V10.1876L9.76042 2.17714Z"
              stroke="#64748B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    )
  }
];

export default columns;
